import { runInAction } from 'mobx';
import { configurationSettings } from '../../../../configuration/configuration-settings';
import { TicketingMode } from '../../../../configuration/types/order/ticketing-mode';
import { logger } from '../../../../utils/logger';
import { nonEmptyStringValidator } from '../../../../utils/validators/string';
import { ticketDetailsValidator } from '../../../../utils/validators/ticket-details';
import { getOrderSelections } from '../../selectors/order/get-order-selections';
import { getOrderSeatsForShowtime } from '../../selectors/seats/get-order-seats-for-showtime';
import { getOrderTicketsForShowtime } from '../../selectors/tickets/get-order-tickets-for-showtime';
import { areOrderTicketRequestsEqual } from '../../utils/tickets/order-ticket-request-utils';
/**
 * Removes all tickets matching the provided ticket details.
 */
export const removeOrderTicketsForShowtime = (showtimeId, ticket) => {
    if (!nonEmptyStringValidator(showtimeId, logger.error, 'showtimeId')) {
        throw new Error('Cannot remove tickets. Provided showtimeId is invalid.');
    }
    if (!ticketDetailsValidator(ticket, logger.error, 'ticket')) {
        throw new Error('Cannot remove tickets. Provided ticket details are invalid.');
    }
    const orderSelections = getOrderSelections();
    const tickets = getOrderTicketsForShowtime(showtimeId);
    if (!tickets.find(t => areOrderTicketRequestsEqual(ticket, t))) {
        logger.debug('Cannot find matching tickets to remove.');
        return;
    }
    const { ticketingMode } = configurationSettings.data.order;
    const isSeatFirstOrdering = ticketingMode === TicketingMode.SeatFirst;
    runInAction(() => {
        orderSelections.showtime = {
            showtimeId,
            tickets: tickets.filter(t => !areOrderTicketRequestsEqual(ticket, t)),
            seats: isSeatFirstOrdering ? getOrderSeatsForShowtime(showtimeId) : []
        };
    });
};
